KMVP.deliveryAddressInformation = {
    bindOpenFormPopupButtons: function () {
        $(document).on('click', '[data-delivery-address-information-form-url]', function () {
            $.ajax({
                url: $(this).data('deliveryAddressInformationFormUrl'),
                type: "GET",
                success: function (data, response) {
                    $.colorbox({
                        innerWidth: '1000px',
                        html: data,
                        scrolling: false,
                        onComplete: KMVP.deliveryAddressInformation.initFormPopup
                    });
                }
            });
        });
    },
    initFormPopup: function () {
        KMVP.deliveryAddressInformation.$formPopup = $('.deliveryAddressInformationFormPopup');
        KMVP.deliveryAddressInformation.validateDeliveryAddressPopUp();
        KMVP.deliveryAddressInformation.displayRestrictionNote();
        KMVP.deliveryAddressInformation.displayWishedTimeStructure();
        KMVP.tooltips.bindTooltips($('#colorbox'));

        if ($('.js-general-delivery-time:checked').val() == 'false') {
            KMVP.deliveryAddressInformation.toggleSelectivGeneralTime();
        }
        else {
            var $helpInline = $('.js-monday-to-friday').find('.help-inline');

            KMVP.deliveryAddressInformation.highlightText($helpInline);
        }

        if ($('.js-delivery-restricted:checked').val() == 'true') {
            $('.js-delivery-restriction-textarea').toggleClass('d-none');
            $.colorbox.resize();
        }


        $('.js-cancel').on('click', function(e) {
            e.preventDefault();
            $.colorbox.close();
        });
    },
    validateDeliveryAddressPopUp: function(){
        $('.js-create-update-address-form').ajaxForm({
            success: function(data) {
                var $summary = $(data).find('.js-summary-delivery-address-information-form');

                if($summary.length) {
                    $('.js-delivery-address-information-form-wrapper').html($summary);
                    KMVP.deliveryAddressInformation.validateDeliveryAddressPopUp();
                    KMVP.deliveryAddressInformation.initFormPopup();
                    $.colorbox.resize();
                } else {
                    window.location.reload();
                }
            }
        });
    },

    //This method should be reconsidered depending on the frontend solution.
    displayRestrictionNote: function() {
        $('.js-delivery-restricted').on('change', function() {
            $('.js-delivery-restriction-textarea').toggleClass('d-none');
            $.colorbox.resize();
        });
    },
    displayWishedTimeStructure: function() {
        $('.js-general-delivery-time').on('change', function() {
            KMVP.deliveryAddressInformation.toggleSelectivGeneralTime();
            $.colorbox.resize();
        });
    },
    toggleSelectivGeneralTime: function(){
        $('.js-monday-to-friday, .js-selective-time').toggleClass('d-none');

        var $helpInline = $('.js-selective-time').find('.help-inline');
        KMVP.deliveryAddressInformation.highlightText($helpInline);

        var $selectList = $('.js-selective-time').find('select');
        $.each($selectList, function(key, value){
            $(value).find("option").first().removeAttr("disabled").show();
        })
        $.colorbox.resize();
    },

    highlightText: function($helpInline){
        if($helpInline.length > 0){
            $helpInline.remove();
            $('.fourHourRestriction').css("color", "#cd1717");
        }
    }

};

$(document).ready(function () {
    if ($("body").hasClass("page-singleStepCheckoutSummaryPage") || $("body").hasClass("page-contractSingleStepCheckoutSummaryPage")) {
        KMVP.deliveryAddressInformation.bindOpenFormPopupButtons();
    }
});
